import { useRef, useState, useCallback } from 'react';
import Form from '@sm/core/Form';

export default function useForm(initialData, fieldRules = []) {
  const formRef = useRef(null);
  const [, forceUpdate] = useState(0);

  // Initialize form instance only once
  if (!formRef.current) {
    formRef.current = new Form(initialData, fieldRules);
  }

  const form = formRef.current;

  const setField = useCallback((fieldName, value) => {
    form[fieldName] = value;
    forceUpdate(n => n + 1); // trigger re-render to reflect changes
  }, [form]);

  const getData = useCallback(() => {
    return form.data();
  }, [form]);

  const validateForm = useCallback(() => {
    const isValid = form.isFormValid();
    forceUpdate(n => n + 1);
    return isValid;
  }, [form]);

  const validateField = useCallback((fieldName) => {
    const isValid = form.isFormFieldValid(fieldName);
    forceUpdate(n => n + 1);
    return isValid;
  }, [form]);

  const reset = useCallback(() => {
    form.reset();
    forceUpdate(n => n + 1);
  }, [form]);

  const reinitialize = useCallback((newInitialData = initialData, newFieldRules = fieldRules) => {
    formRef.current = new Form(newInitialData, newFieldRules);
    forceUpdate(n => n + 1);
  }, [initialData, fieldRules]);

  return {
    form,
    setField,
    getData,
    validateForm,
    validateField,
    reset,
    reinitialize,
    errors: form.errors.getErrors(),
  };
}
